// extracted by mini-css-extract-plugin
export var chip = "_c9-0";
export var filterDropdown = "_c9-5";
export var filterItem = "_c9-6";
export var icon = "_c9-1";
export var removeButton = "_c9-3";
export var removeIcon = "_c9-4";
export var separator = "_c9-2";